import { PluginFunction } from 'vue';

import { PageService } from '../services/page.service';
import { ResourceService } from '../services/resource.service';
import { ApartmentService } from '../services/apartment.service';
import { SystemService } from '../services/system.service';
import { LocationService } from '../services/location.service';
import { CookiesService } from '../services/cookies.service';
import { MailService } from '../services/mail.service';
import { UserService } from '../services/user.service';
import { Store } from '../store';

export const Services: PluginFunction<{store: Store}> = (Vue, options) => {
	const store = Vue.prototype.$store;

	Vue.prototype.$apartmentService = new ApartmentService(store);
	Vue.prototype.$systemService = new SystemService(store);
	Vue.prototype.$cookiesService = new CookiesService(store);
	Vue.prototype.$locationService = new LocationService(store);
	Vue.prototype.$mailService = new MailService(store);
	Vue.prototype.$pageService = new PageService(store);
	Vue.prototype.$resourceService = new ResourceService(store);
	Vue.prototype.$userService = new UserService(store);
}

declare module "vue/types/vue" {
	interface Vue {
		$apartmentService: ApartmentService;
		$systemService: SystemService;
		$cookiesService: CookiesService;
		$locationService: LocationService;
		$mailService: MailService;
		$pageService: PageService;
		$resourceService: ResourceService;
		$userService: UserService;
	}
}
